import styles from './Preview.module.scss';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { DictionaryContext } from 'application/adapters/context/Dictionary';
import { PageContentResponse } from 'application/repositories/pageContentRepository';

export interface PreviewProps {
	content: PageContentResponse;
	children: React.ReactNode;
}

export const Preview: React.FC<PreviewProps> = ({ children, content }) => {
	const { isPreview } = useRouter();
	const dictionary = useContext(DictionaryContext);

	if (!isPreview) return <>{children}</>;

	return (
		<div className={styles.Preview}>
			<div className={styles.Preview_top}>
				<p>
					{dictionary.getValue('Preview.InPreview')}{' '}
					<a className={styles.Preview_link} href={`/api/exitPreview?slug=${content.page.url}`}>
						{dictionary.getValue('Preview.ExitPreview')}
					</a>
				</p>
			</div>
			<div className={styles.Preview_content}>{children}</div>
		</div>
	);
};
